(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/services/assets/actions/wagers.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/services/assets/actions/wagers.js');
"use strict";



const _RTK = RTK,
  createAsyncThunk = _RTK.createAsyncThunk;
const _svs$core = svs.core,
  jupiter = _svs$core.jupiter,
  userSession = _svs$core.userSession,
  session = _svs$core.session;
const FetchState = svs.components.marketplaceCompetition.constants.FetchState;

const normalizeWagers = svs.components.marketplaceCompetition.services.helpers.normalizeWagers.normalizeWagers;
const WAGER_CACHE_TIME = 5000;
const logger = svs.core.log.getLogger('marketplace-competition:wagers');

const fetchWagers = createAsyncThunk('fetchWagers', _fetchWagerPayloadCreator, {
  condition: _fetchWagerConditionCallback
});

async function _fetchWagerPayloadCreator(competitionId) {
  if (session.data.userSession.isAnonymous) {
    logger.info("Mkp-competition: fetchwagers isAnonymous, wagers.es6");
    throw new Error('Can\'t fetchWagers with anonymous session');
  }
  const result = await jupiter.callAsync({
    method: 'GET',
    path: "/player/1/competitions/".concat(competitionId, "/wagers?include=wagers.wagerId,wagers.currentDrawNumber")
  });
  return normalizeWagers(result.response.wagers);
}

function _fetchWagerConditionCallback(competitionId, _ref) {
  let getState = _ref.getState;
  const isPlayer = userSession.hasRole(userSession.roles.PLAYER);
  if (!isPlayer) {
    return false;
  }
  const wagers = getState().Competition.Wagers[competitionId];
  if (wagers) {
    const status = wagers.status,
      lastFetch = wagers.lastFetch;
    const earliestNextFetchTS = new Date(lastFetch).getTime() + WAGER_CACHE_TIME;
    if (status === FetchState.Pending || Date.now() < earliestNextFetchTS) {
      return false;
    }
  }
  return true;
}

setGlobal('svs.components.marketplaceCompetition.services.actions.wagersActions', {
  fetchWagers
});

 })(window);